import HOLTER_TASKS_QUERY from '@/entities/study/api/queries/holterTasks';
import { createClient } from '@/shared/api';
import type { HolterTasksQuery, HolterTasksQueryVariables } from '@/shared/api/generated/graphql';

export type HolterTasks = {
  isSuccess: boolean;
  message: string;
  tasks: {
    users: { id: string; firstName: string; lastName: string }[];
    study: { friendlyId: string };
  }[];
  pendingProfiles: { id: string; study: { friendlyId: string } }[];
  limitWorker: number;
};

/**
 * Loads the holter worker queue with its pending profiles and running tasks. Runs the holterTasks query and returns it on success, throwing the server message otherwise.
 *
 * @returns A promise resolving to the holter tasks payload.
 */
const fetchHolterTasks = async () => {
  const client = await createClient();
  const result = await client.query<HolterTasksQuery, HolterTasksQueryVariables>({
    query: HOLTER_TASKS_QUERY,
  });
  const { data } = result;
  const { holterTasks } = data;
  if (holterTasks?.isSuccess) {
    return holterTasks;
  }
  throw new Error(holterTasks?.message);
};

export default fetchHolterTasks;
